<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <div class="col-md-12 index-up">
                <app-breadcrumb></app-breadcrumb>
                <h2>{{description?.Title}}</h2>
                <p *ngIf="!isclicked" class="text-primary size18 font-weight-semibold">{{description?.Contenu}}
                </p>
                <p *ngIf="!isclicked" class="font-weight-semibold text-uppercase">Cherchez un offre d'emplois</p>
                <form *ngIf="!isclicked" class="form-ap" #formFilter="ngForm">
                    <div class="form-row">
                        <div class="col-md-4">
                            <label for="tag">Mots clés</label>
                            <input ngModel name="ObjetAppelOffre" class="form-control" id="tag" type="text"
                                placeholder="Saisissez un mot clé">
                        </div>
                        <div class="col-md-4">
                            <label for="Types">Type du concours</label>
                            <select ngModel name="Type" class="form-control" id="Type">
                                <option value="">Choisissez</option>
                                <option *ngFor="let t of Types" [value]="t">{{t}}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="Etapes">Etape du concours</label>
                            <select ngModel name="Etape" class="form-control" id="Etapes">
                                <option value="">Choisissez</option>
                                <option *ngFor="let e of Etapes" [value]="e">{{e}}</option>
                            </select>
                        </div>
                    </div>
                    <button class="btn btn-info pr-5" (click)="lancerFilter(formFilter.value)">Lancer la recherche<span
                            class="icon-search"></span></button>
                </form>
            </div>
        </div>
    </div>
    <div *ngIf="isclicked" class="container">
        <div class="row">
            <div class="col-md-3 side-bar">
                <div class="selected-item">      </div> 
            <nav id="sidebar">
              <app-statique-menu
                [lg]="outputLg"
                [cururl]="currentUrl"
              ></app-statique-menu>
            </nav>
          </div>
          <div class="col-md-9">
            <div style="padding: 20px 2rem;">
                <div class="OffreEmploi2">
                    <h3>L'annonce </h3>
                    <p>
                        <strong>
                            <span >L'Agence Nationale
                                des Ports organise un concours pour le Recrutement de {{selectedOffre?.Title}} selon le profil
                                ci-dessous :</span>
                        </strong>
                    </p>
                    <br>
                    <table style="width: 100%;">
                        <tbody>
                            <tr>
                                <td>
                                    <h4>Poste : </h4>
                                </td>
                                <td>
                                    <p>
                                        <span> {{selectedOffre?.Title}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Numero du Poste : </h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{selectedOffre?.Num_Poste}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Formation : </h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{selectedOffre?.Formation}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Spécialité : </h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{selectedOffre?.Specialite}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Expérience : </h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{selectedOffre?.Experience}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Nombre : </h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{selectedOffre?.NbPoste}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Date de publication de l'annonce :</h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{converteDate(selectedOffre?.DatePublication)}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h4>Délai de dépôt des candidatures :</h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{converteDate(selectedOffre?.DelaiDepot)}}</span>
                                    </p>
                                </td>
                            </tr>
        
                            <tr>
                                <td>
                                    <h4>Epreuve ecrite :</h4>
                                </td>
                                <td>
                                    <p>
                                        <span>{{converteDate(selectedOffre?.DateConcours)}}</span>
                                    </p>
                                </td>
                            </tr>
                            <tr *ngIf="annonce">
                                <td>
                                    <h4>L'Annonce :</h4>
                                </td>
                                <td><span><a [href]="annonce?.ServerRelativeUrl" target="_blank">Télécharger le pdf</a></span></td>
                            </tr>
                            <tr *ngIf="fiche">
                                <td>
                                    <h4>Fiche de poste :</h4>
                                </td>
                                <td><span><a [href]="fiche?.ServerRelativeUrl" target="_blank">Télécharger le pdf</a></span></td>
                            </tr>
                            <tr *ngIf="appreciation">
                                <td>
                                    <h4>Fiche appreciation :</h4>
                                </td>
                                <td><span><a [href]="appreciation?.ServerRelativeUrl" target="_blank">Télécharger le pdf</a></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <div *ngIf="!canCandidate && (ecrite || orale || resultats)" class="OffreEmploi2">
                        <h3>Résultats</h3>
                        <table style="width: 100%; border:0px;">
                            <tbody>
                                <tr *ngIf="ecrite">
                                    <td>Sélection épreuve écrite :</td>
                                    <td><span><a [href]="ecrite?.ServerRelativeUrl" target="_blank">Télécharger le pdf</a></span></td>
                                </tr>
                                <tr *ngIf="orale">
                                    <td>Sélection épreuve orale :</td>
                                    <td><span><a [href]="orale?.ServerRelativeUrl" target="_blank">Télécharger le pdf</a></span></td>
                                </tr>
                                <tr *ngIf="resultats">
                                    <td>Liste des admis :</td>
                                    <td><span><a [href]="resultats?.ServerRelativeUrl" target="_blank">Télécharger le pdf</a></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="canCandidate" class="OffreEmploi2">
                        
                        <table style=" border:0px;">
                            <tbody>
                                <tr>
                                    <td>Déposer une candidature :</td>
                                    <td><span><a href="javascript:void(0)" [routerLink]="['/publications/offres-emplois/deposer-candidature',selectedOffre.Id]" routerLinkActive="router-link-active" >Cliquer ici</a></span></td>
                                </tr>
                         
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    <section *ngIf="!isclicked" class="c-appels-offres">
        <div class="container">
            <div class="row">
                <div class="col d-flex justify-content-between">
                    <h2 class="size18 text-uppercase mb-3">Résultat de recherche : </h2>
                    <p class="size18 text-uppercase text-white mt-4 pt-1 mb-3">
                        {{lenth}}
                        Offres d'emploi trouvés</p>
                </div>
            </div>
            <!-- <div class="row slickappel" data-aos="fade-up">
                <div class="col-md-12" *ngFor="let offres of dataOffres">
                    <a *ngFor="let offre of offres" routerLink="{{offre.ID}}"
                        class="block-appels d-flex align-items-start flex-column">
                        <div class="d-flex justify-content-between w-100">
                            <div class="num-appel-offre">{{offre.EtapeActuelle}} ( {{offre.Annonce}} )</div>
                            <div class="date-appels mt-auto">{{converteDate(offre.DatePublication)}} </div>
                        </div>
                        <h3 class="titre-appels size18"> {{offre.Title}} </h3>
                    </a>
                </div>
            </div> -->
            <table id="offres" class="table table-striped table-bordered" style="width:100%">
                <thead>
                    <tr>
                        <th>Publié le</th>
                        <th>Avis pour</th>
                        <th>Étape</th>
                        <th>Type de concours</th>
                    </tr>
                </thead>
            </table>
        </div>
    </section>
</main>